<template>
    <div>
        <div>
            <div class="container mx-auto">
                <div class="lg:w-1/3 w-1/2 mx-auto text-center pt-24" :class="{ 'text-white text-xl': dark, 'text-black text-xl': !dark}">
                    Nous proposons des services indispensables pour que vos projets prennent <div class="inline" :class="{ 'text-blueviolet long_shot text-2xl':dark, 'blue-text text-3xl paul_signature':!dark }">vies.</div>
                </div>
            </div>
            <!-- Container -->
            <div class="max-w-screen-xl mx-auto px-4 py-12">
                <!-- Grid wrapper -->
                <div class="-mx-4 flex flex-wrap pt-12">
                    <!-- Grid column -->
                    <div class="w-full flex flex-col p-10 md:w-1/2">
                        <!-- Column contents -->
                        <div class="relative flex-1 mx-0 my-0 md:mx-12 md:my-12 px-12 py-12 shadow-lg justify-center" :class="{'bg-white': !dark, 'hover:transition duration-500 hover:bg-white text-white hover:text-black':dark}">
                            <!-- Card contents -->
                            <div class="w-full flex mb-4">
                                <font-awesome-icon class="text-xl mx-auto" :class="{'text-red-500': !dark, 'text-blueviolet':dark}" :icon="['fa', 'laptop-code']"/>

                            </div>
                            <h2 class="text-xl uppercase text-center droidiga" :class="{'text-red-500': !dark, 'text-blueviolet':dark}">Développement Web</h2>
                            <p class="py-4 text-justify orphans">
                            Construisons vos projet Web : Site Web vitrine et e&#8209;commerce, Application Web et mobile, API... Nous vous conseillons, dimenssionons, réalisons des solutions adaptées à vos besoins.
                            </p>
                           
                        </div>
                        
                    </div>
                    <!-- Grid column -->
                    <div class="w-full flex flex-col p-10 md:w-1/2">
                        <!-- Column contents -->
                        <div class="relative flex-1 mx-0 my-0 md:mx-12 md:my-12 px-12 py-12 shadow-lg justify-center" :class="{'bg-white': !dark, 'hover:transition duration-500 hover:bg-white text-white hover:text-black':dark}">
                            <!-- Card contents -->
                            <div class="w-full flex mb-4">
                                <font-awesome-icon class="text-xl mx-auto" :class="{'text-red-500': !dark, 'text-blueviolet':dark}" :icon="['fa', 'pen']"/>
                            </div>
                            <h2 class="text-xl uppercase text-center droidiga" :class="{'text-red-500': !dark, 'text-blueviolet':dark}">Communication Visuelle</h2>
                            <p class="py-4 text-justify">
                            De l’identité visuelle aux bannières pour les réseaux sociaux, notre équipe comm vous assure des supports Digitaux et Print en adéquation avec les valeurs de votre entreprise. (Identité visuelle, affiche, plaquette, illustrations, Design web, etc..) 
                            </p>
                        </div>
                    </div>
                    <!-- Grid column -->
                    <div class="w-full flex flex-col p-10 md:w-1/2">
                        <!-- Column contents -->
                        <div class="relative flex-1 mx-0 my-0 md:mx-12 md:my-12 px-12 py-12 shadow-lg justify-center" :class="{'bg-white': !dark, 'hover:transition duration-500 hover:bg-white text-white hover:text-black':dark}">
                            <!-- Card contents -->
                            <div class="w-full flex mb-4">
                                <font-awesome-icon class="text-xl mx-auto" :class="{'text-red-500': !dark, 'text-blueviolet':dark}" :icon="['fa', 'tools']"/>
                            </div>
                            <h2 class="text-xl uppercase text-center droidiga" :class="{'text-red-500': !dark, 'text-blueviolet':dark}">Service</h2>
                            <p class="py-4 text-justify">
                            Maintenance informatique, référencement, rédaction, évolutions... Nous vous proposons des services pour péréniser vous outils web et de communication.

                            </p>
                        </div>
                    </div>
                    <!-- Grid column -->
                    <div class="w-full flex flex-col p-10 md:w-1/2">
                        <!-- Column contents -->
                        <div class="relative flex-1 mx-0 my-0 md:mx-12 md:my-12 px-12 py-12 shadow-lg justify-center" :class="{'bg-white': !dark, 'hover:transition duration-500 hover:bg-white text-white hover:text-black':dark}">
                            <!-- Card contents -->
                            <div class="w-full flex mb-4">
                                <font-awesome-icon class="text-xl mx-auto" :class="{'text-red-500': !dark, 'text-blueviolet':dark}" :icon="['fa', 'video']"/>
                            </div>
                            <h2 class="text-xl uppercase text-center droidiga" :class="{'text-red-500': !dark, 'text-blueviolet':dark}">Vidéo</h2>
                            <p class="py-4 text-justify">
                            La vidéo est désormais un outil digital majeur. Notre équipe vous propose aussi bien des vidéos dites «institutionnelles» que des vidéos artistiques sur le ton des mini-court métrage pour promouvoir votre entreprise/marque.

                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-16 w-full">
                <div class="md:ml-auto lg:ml-auto xl:ml-auto md:mr-0 lg:mr-0 xl:mr-0 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full flex">
                    <h1 class="mx-auto lg:text-5xl text-5xl uppercase droidiga" :class="{'blue-text':!dark, 'text-blueviolet':dark}">Contact</h1>
                </div>
            </div>
        </div>
    </div>
</template>
<script src="dynamics.js"></script>

<script>
export default {
  name: 'Services',
  props: {
    dark: {
      type: Boolean
    }
  },
}
</script>
<style scoped>

p {
    font-size: 11pt;
    animation-name: sliderText;
    animation-duration: 1s;
}

@keyframes sliderText {
  from {
      transform: translate(-50%, -50%);
      opacity: 0;
      }
  to {
      transform: translate(0%, 0%);
      opacity: 1;
      }
}

</style>